<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Insumo</th>
                            <th class="item-number text-right">Precio de compra</th>
                            <th class="item-number text-right">Cantidad</th>
                            <th class="item-number text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in supplies" :key="item.id">
                            <td>{{ item.item_name }}</td>
                            <td class="text-right">{{ item.price | currency('S/') }}</td>
                            <td class="text-right">{{ item.quantity }}</td>
                            <td class="text-right">{{ item.subtotal | currency('S/') }}</td>
                        </tr>                        
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="foot-purchase"></td>
                            <td class="font-weight-medium">Subtotal</td>
                            <td class="text-right">{{ purchase.subtotal | currency('S/') }}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="foot-purchase"></td>                          
                            <td class="font-weight-medium">IGV</td>
                            <td class="text-right">{{ purchase.igv | currency('S/') }}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="foot-purchase"></td>
                            <td class="font-weight-medium">Total</td>
                            <td class="text-right">{{ purchase.total | currency('S/') }}</td>
                        </tr>
                    </tfoot>

                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ApiReports from '../../apis/Reports'
export default {
    name: 'PurchaseDetail',
    props: ['purchase', 'supplies'],
    data() {
        return {
            detail: []
        }
    },
    methods:{
        showForm(title, purchase) {
            this.titleForm = title
            this.purchase = purchase
            this.drawer = !this.drawer
        },
        getDetail(){
            let params = {
                purchase_id: this.purchase.id
            }
            
            ApiReports.getPurchaseDetail(params)
                    .then(({data}) => {
                        this.detail = data
                    })
        }
    },
    mounted(){
        console.log('detalle de compra')
    }
}
</script>

<style scoped>
.item-number{
    width: 150px !important;
    min-width: 150px !important;
}

.foot-purchase{
    border-bottom: 0px !important;
}
</style>